<template>
    <div class="newsNew-section" :style="styleObj" v-loading="loading">
        <slot name="module-header"></slot>
        <div class="newsNew-section-content">
            <template v-if="mode === 'simple'">
                <div class="content-list"   v-for=" (item,index) in data" @click="$emit('go-to-news-detail', item,index,moduleIndex)" :key = "index" @mouseenter="hoverStatus=index" @mouseleave="hoverStatus=-1" :class="{'content-list-hoverStatus' : hoverStatus=== index}" >
                    <SimpleNewsItem :data="item"/>
                </div>
            </template>
            <template v-else>
                <div class="content-list" v-for=" (item,index) in data.slice(0,picNumber)" @click="$emit('go-to-news-detail', item,index,moduleIndex)" :key = "index" @mouseenter="hoverStatus=index" @mouseleave="hoverStatus=-1" :class="{'content-list-hoverStatus' : hoverStatus=== index}">
                    <NewsItemWithPic :data="item" />
                </div>
                <div class="content-list" v-for=" (item,index) in data.slice(picNumber)"  @click="$emit('go-to-news-detail', item,index + picNumber,moduleIndex)" :key = "index+'9'" @mouseenter="hoverStatus=index+9" @mouseleave="hoverStatus=-1" :class="{'content-list-hoverStatus' : hoverStatus=== index+9}">
                    <SimpleNewsItem :data="item" />
                </div>
            </template>
            <template v-if="data.length === 0 && !loading">
                <NoData :type="noDataType" />

            </template>
        </div>
    </div>
</template>

<script>
    import SimpleNewsItem from "./simpleNewsItem";
    import NewsItemWithPic from "./newsItemWithPic";
    import NoData from './noData.vue';

    export default {
        name: "NewsModule",
        data(){
            return {
                hoverStatus: -1
            }
        },
        props: {
            styleObj:{ type:Object, default: ()=> {} },
            data: { type: Array, default: () => []},
            // 列表展示模式，simple,列表不显示图片，其他值会显示图片
            mode: {type: String, default: 'simple'},
            // 列表展示模式为图片模式，显示的个数，是从头部开始
            picNumber: {type: Number, default:3},
            noDataType: { type: String, default:'module'},
          loading:{ type: Boolean, default:false},
          moduleIndex: {type: Number, default:0},

        },
        created() {
          console.log('this.loading', this.loading, this.data,this.moduleIndex)

        },
        components: {
            SimpleNewsItem,
            NewsItemWithPic,
            NoData
        },
    }
</script>

<style scoped lang="scss">
  @import "@/styles/variables.scss";
 .newsNew-section {
     border-radius: 6px;
     background-color: rgba(255,255,255,0.95);
     position: relative;
   border-top:3px solid $color-primary;
   overflow: hidden;
     &-content {
         padding: 0 30px;
         .content-list {
             padding: 7px 0 8px 0;
             border-bottom: 1px solid #E6E6E6;
             &:nth-last-child(1) {
                 border: none;
             }
             &-hoverStatus {
                 /*box-shadow: 0px 1px 10px 0px rgba(14, 108, 203, 0.1);*/
                 /*background-color: rgba(255, 255, 255, 1);*/
                 /*border: none;*/
                 /*transition: all 0.5s;*/
                 cursor: pointer;
             }
             &.readed-active {
             }
            //  box-shadow: 0px 1px 10px 0px rgba(14, 108, 203, 0.1);

         }

     }
 }
</style>